import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductUnitOfMeasure from "@WhiteCap/Components/ProductUnitOfMeasure";
import GuestProductListActions from "@WhiteCap/Widgets/GuestRFQ/GuestProductListActions";
import React, { FC } from "react";
import { css } from "styled-components";

// EC-234 : SubTask - EC-282 = Creating a PLP variant for Guest User

type Props = ProductCardSelections & HasProduct;

export interface GuestProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
}

export const guestProductGridCardStyles: GuestProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 10px;
            align-items: center;
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
};

const styles = guestProductGridCardStyles;

const GuestProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}) => {
    const SponsoredText = product.isSponsored ? (
        <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
    ) : null;

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            <StyledWrapper>
                {SponsoredText}
                <ProductListProductImage
                    showImage={showImage}
                    showCompare={showCompare}
                    showImageBadge={showImageBadges}
                    showTextBadge={showTextBadges}
                />
            </StyledWrapper>
            <ProductListProductInformation
                showAttributes={showAttributes}
                showAvailability={false}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
            />
            
            <GuestProductListActions showAddToList={showAddToList} showPrice={showPrice} />
        </StyledWrapper>
    );
};

export default withProduct(GuestProductListProductGridCard);

// EC-234 : SubTask - EC-282 = Creating a PLP variant for Guest User
